import CLOHelpCenter from "./SVGIcons/CLOHelpCenter";

type Props = {
  className?: string;
  logo?: JSX.Element;
  title: string;
  url: string;
  contentDescription?: string;
  createdAt?: string;
  onMouseLeave?: () => void;
};

const AnswerCitationModal = ({
  className,
  logo,
  title,
  url,
  contentDescription,
  createdAt,
  onMouseLeave,
}: Props) => {
  return (
    <div
      className={`${className} z-10 pt-[10px]`}
      onMouseLeave={onMouseLeave}
      onClick={(event) => {
        window.open(url, "_blank");
      }}
    >
      <ul className="flex cursor-pointer flex-col gap-1 rounded-lg bg-grayscale-solid-elevate-level2 p-2.5 shadow-md">
        <li className="">
          <h1
            className={`text-sm font-bold ${!contentDescription && "w-max"} text-grayscale-solid-g9`}
          >
            {title}
          </h1>
        </li>
        {createdAt && (
          <li className="text-xs font-normal">
            <p className="line-clamp-1 w-[250px] text-xs font-normal text-grayscale-solid-g9">
              {createdAt}
            </p>
          </li>
        )}
        {contentDescription && (
          <li className="font-bold">
            <p className="line-clamp-3 w-[250px] text-sm font-normal text-grayscale-solid-g9">
              {contentDescription}
            </p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default AnswerCitationModal;
